import { render, staticRenderFns } from "./cardAssistance.vue?vue&type=template&id=d9bb6c02&"
import script from "./cardAssistance.vue?vue&type=script&lang=js&"
export * from "./cardAssistance.vue?vue&type=script&lang=js&"
import style0 from "./cardAssistance.vue?vue&type=style&index=0&id=d9bb6c02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports